import { Fragment, h } from 'preact'; /** @jsx h */
import { Checkbox, Input } from '../components/input';
import { datoToText } from '../components/utils';

const RedigerFravaerDager = ({
  fravaersDager,
  fjernDato,
  onChangeEndre,
  onToggleEndre,
  fjernDisabled,
  type
}) => {
  const datoVarsel = {
    1: 'Dato er sendt til regnskap, kan ikke endres',
    2: 'En annen syke- eller egenmelding er registrert denne datoen',
    3: 'Vanlig arbeidstimer er registrert denne datoen'
  };

  return (
    <table className="pa3 w-100 td-l1 mb3-halv" id="fravaermelding-liste">
      <thead className="bt b--black">
        <tr className="tr">
          <th>Dato</th>
          <th>Aktiv arbeidstid</th>
          <th>Passiv reisetid</th>
          {Object.keys(fravaersDager).some(
            (dato) => fravaersDager[dato].reiseid > 0
          ) && <th>Reisetillegg</th>}
        </tr>
      </thead>
      <tbody>
        {Object.keys(fravaersDager).map((dato, index) => {
          return (
            <tr key={index} className="tr">
              <td>{datoToText(dato)}</td>
              <Fragment key={index}>
                {fravaersDager[dato].status ? (
                  <Fragment>
                    <td key={index} className="primary">
                      {datoVarsel[fravaersDager[dato].status]}
                    </td>
                    <td></td>
                  </Fragment>
                ) : (
                  <Fragment>
                    {fravaersDager[dato].regtim === 'N' ? (
                      <Fragment>
                        <td className="pa3" colSpan={2}>
                          Dagen skal ikke registreres med timer
                        </td>
                        {fravaersDager[dato].reiseid > 0 && (
                          <td>
                            <Checkbox
                              label=""
                              name={`ikke_rt_${dato}`}
                              checked={fravaersDager[dato].ikke_rt !== 'J'}
                              onChange={() => onToggleEndre('ikke_rt', dato)}
                            />
                          </td>
                        )}
                      </Fragment>
                    ) : (
                      <Fragment>
                        <td>
                          <Input
                            type="number"
                            name={fravaersDager[dato].aktiv}
                            value={parseFloat(fravaersDager[dato].aktiv)}
                            onChange={(e) => onChangeEndre(e, 'aktiv', dato)}
                            step={0.25}
                            min={0}
                            required={true}
                          ></Input>
                        </td>
                        <td>
                          <Input
                            type="number"
                            name={fravaersDager[dato].passiv}
                            value={parseFloat(fravaersDager[dato].passiv)}
                            onChange={(e) => onChangeEndre(e, 'passiv', dato)}
                            step={0.25}
                            min={0}
                            required={true}
                          ></Input>
                        </td>
                        <td>
                          {fravaersDager[dato].reiseid > 0 && (
                            <Checkbox
                              label=""
                              name={`ikke_rt_${dato}`}
                              checked={fravaersDager[dato].ikke_rt !== 'J'}
                              onChange={() => onToggleEndre('ikke_rt', dato)}
                            />
                          )}
                        </td>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </Fragment>
              {type === 'S' && fravaersDager[dato].regtim !== 'N' && (
                <button
                  onClick={(e) => fjernDato(dato, e)}
                  disabled={fjernDisabled || fravaersDager[dato].status === 1}
                  type="button"
                >
                  Fjern
                </button>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default RedigerFravaerDager;
